import { TextV2 } from 'components/TextV2/TextV2';
import React, { FC } from 'react';
import cx from 'classnames';
import styles from './FeaturesModalBody.module.scss';
import { Features } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';

interface IFeaturesModalBodyProps {
  features?: FlatEntry<Features>[];
}

export const FeaturesModalBody: FC<IFeaturesModalBodyProps> = ({ features }) => {
  if (!features || features.length === 0) {
    return null;
  }

  const renderFeatures = (feature: FlatEntry<Features>) => {
    return (
      <div className={cx(styles.items, styles.itemsDisplay)}>
        <TextV2 tagName="h5" variant="body-medium" value={feature.title} className={styles.header} />
        <TextV2
          isMarkdown
          tagName="small"
          variant="body-small"
          value={feature.blurb?.blurb}
          className={styles.content}
        />
      </div>
    );
  };

  return <>{features.map(feature => renderFeatures(feature))}</>;
};
